import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSchemaScopedStorageKey } from '@/lib/schemaStorage';

import roTranslations from './locales/ro.json';
import enTranslations from './locales/en.json';

const resources = {
  ro: {
    translation: roTranslations
  },
  en: {
    translation: enTranslations
  }
};

// Funcție pentru a obține limba salvată din localStorage sau browser
const getInitialLanguage = (): string => {
  // Verifică dacă există o preferință salvată
  const storageKey = getSchemaScopedStorageKey('i18nextLng');
  const savedLanguage = localStorage.getItem(storageKey);
  if (savedLanguage && (savedLanguage === 'ro' || savedLanguage === 'en')) {
    return savedLanguage;
  }
  
  // Detectează limba din browser
  const browserLanguage = navigator.language || (navigator as any).userLanguage;
  if (browserLanguage.startsWith('en')) {
    return 'en';
  }
  
  // Fallback la română
  return 'ro';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ro',
    lng: getInitialLanguage(),

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Configurări pentru debugging (dezactivează în producție)
    debug: false,
  });

// Salvează limba în localStorage când se schimbă
i18n.on('languageChanged', (lng) => {
  const storageKey = getSchemaScopedStorageKey('i18nextLng');
  localStorage.setItem(storageKey, lng);
});

export default i18n;
